import React from 'react';

const InRestaurantIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 -960 960 960"
      {...props}
    >
      <path
        fill="currentColor"
        d="M300-100v-361.385q-46.385-7.076-78.577-42.538-32.192-35.462-32.192-86.846V-860h40v269.231H300V-860h40v269.231h70.769V-860h40v269.231q0 51.384-32.192 86.846T340-461.385V-100h-40zm369.231 0v-320h-98.462v-260q0-66.846 37.731-118.423t100.731-60.039V-100h-40z"
      ></path>
    </svg>
  );
};

export default InRestaurantIcon;
